module.exports = __webpack_public_path__ + "static/events-white-light-fb08c888bab346e97e04fc841c0aafec.jpg";